module.exports = __webpack_public_path__ + "img/app_phrase.ebaa4514.png";